import { Component } from '@angular/core';

@Component({
  selector: 'app-validate-account',
  templateUrl: './validate-account.component.html',
  styleUrl: './validate-account.component.css'
})
export class ValidateAccountComponent {

}
